var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import CurrentUserDetailsActionConstants from "./CurrentUserDetailsActionsConstants.js";
import { getDefaultAsyncWrapperObj, getCompletedAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
const getDefaultState = () => {
  return {
    currentUser: null,
    // @ts-ignore
    userAffinity: getDefaultAsyncWrapperObj(),
    // @ts-ignore
    experimentationGroup: getDefaultAsyncWrapperObj()
  };
};
const CurrentUserDetailsReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case CurrentUserDetailsActionConstants.UPDATED_CURRENT_USER_METADATA:
      const result1 = actionResult;
      if (!!result1.error) {
        return state;
      }
      return __spreadProps(__spreadValues({}, state), {
        currentUser: result1.payload.userDetails
      });
    case CurrentUserDetailsActionConstants.LOADING_USER_AFFINITY:
      return __spreadProps(__spreadValues({}, state), {
        userAffinity: __spreadProps(__spreadValues({}, state.userAffinity), {
          status: AsyncRequestStatus.Pending
        })
      });
    case CurrentUserDetailsActionConstants.LOADED_USER_AFFINITY:
      const result2 = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        userAffinity: getCompletedAsyncWrapperObj(result2.payload, result2.error)
      });
    case CurrentUserDetailsActionConstants.LOADING_EXPERIMENTATION_GROUP:
      return __spreadProps(__spreadValues({}, state), {
        experimentationGroup: __spreadProps(__spreadValues({}, state.experimentationGroup), {
          status: AsyncRequestStatus.Pending
        })
      });
    case CurrentUserDetailsActionConstants.LOADED_EXPERIMENTATION_GROUP:
      const result3 = actionResult;
      const { experimentationGroup, error } = result3.payload;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experimentationGroup: getCompletedAsyncWrapperObj(experimentationGroup, error)
      });
    default:
      return state;
  }
};
const CurrentUserDetailsReducersMapObject = {
  currentUserDetails: CurrentUserDetailsReducer
};
export {
  CurrentUserDetailsReducer,
  CurrentUserDetailsReducersMapObject,
  CurrentUserDetailsReducersMapObject as default,
  getDefaultState
};
//# sourceMappingURL=CurrentUserDetailsReducer.js.map
